import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';

export const useDownloadStyles = createStyles(() => ({
  downloadReportPage: {
    h1: {
      marginBottom: ThemeSpaces.SPACE_XL,
    },

    '.ant-btn-primary': {
      width: 300,
    },
  },
  downloadReportContent: {
    margin: `80px ${ThemeSpaces.SPACE_XL}px`,
    display: 'flex',
    alignItems: 'center !important',
  },
}));
